import { useState } from 'react';
import { Box, Button, Typography, Popover, Skeleton } from '@mui/material';
import { RgbaStringColorPicker } from 'react-colorful';
import { THEME_DEFAULT_COLOR } from '../../utils/constants';
import './ColorField.css';

interface ColorFieldProps {
  label: string;
  value: string;
  onChange: (val: string) => void;
  onCommit: () => void;
  loading?: boolean;
}

const ColorField = ({ label, value, onChange, onCommit, loading }: ColorFieldProps) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  if (loading) {
    return (
      <Box className="color-field">
        <Typography variant="subtitle2" className="color-field__label" sx={{ color: 'text.secondary' }}>
          {label}
        </Typography>
        <Skeleton variant="rounded" width={56} height={32} className="color-field__swatch-skeleton" />
        <Skeleton variant="text" width={88} height={16} />
      </Box>
    );
  }

  return (
    <Box className="color-field">
      <Typography variant="subtitle2" className="color-field__label" sx={{ color: 'text.secondary' }}>
        {label}
      </Typography>
      <Button
        className="color-field__swatch"
        onClick={(e) => setAnchor(e.currentTarget)}
        style={{ backgroundColor: value || THEME_DEFAULT_COLOR }}
        sx={{ border: '1px solid', borderColor: 'divider' }}
      />
      <Typography variant="caption" className="color-field__value" sx={{ color: 'text.disabled' }}>
        {value || THEME_DEFAULT_COLOR}
      </Typography>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => { setAnchor(null); onCommit(); }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        className="popover-theme-option"
      >
        <RgbaStringColorPicker color={value || THEME_DEFAULT_COLOR} onChange={onChange} />
      </Popover>
    </Box>
  );
};

export default ColorField;
